import React from "react";
import "./Footer.scss"
import fb from "../../assets/icons/fb.svg"
import insta from "../../assets/icons/insta.svg"
import twitter from "../../assets/icons/twitter.svg"
import tripad from "../../assets/icons/tripad.svg"
import logo from "../../assets/logo.png"
import Button from "../Button/Button";
import MapLocationComponent from "./MapLocationComponent";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";


const Footer = () => {
    const history = useHistory()
    const isComingSoon = window.location.pathname === "/coming-soon"
    const companyDetails = useSelector((state) => state.companyData.companyDetails);

    const links = [
        {
            "Title": "Home",
            "Link": "/"
        }, {
            "Title": "Book A Table",
            "Link": "/"
        }, {
            "Title": "Menu",
            "Link": "/menu"
        }, {
            "Title": "Click & Collect",
            "Link": "/"
        }, {
            "Title": "The Restaurant",
            "Link": "/"
        }, {
            "Title": "Gallery",
            "Link": "/"
        }, {
            "Title": "About",
            "Link": "/"
        },
        {
            "Title": "Events",
            "Link": "/"
        }
    ]
    return (
        <div className="VirasatDefault-Footer">
            {companyDetails?.settings?.ShowAddressInMap && <MapLocationComponent lat={companyDetails?.address?.lat}
                lng={companyDetails?.address?.lng}
            />}
            <div className="VirasatDefault-Footer-top">
                <div className="VirasatDefault-Footer-top-inner">
                    <div className="VirasatDefault-Footer-top-inner-cont">
                        <div className="footer-VirasatDefault-header-logo">
                            <div className="footer-VirasatDefault-header-logo-cont">
                                <img alt="" className="footer-VirasatDefault-header-logo-cont-img" src={logo} />
                            </div>
                            <div className="footer-VirasatDefault-header-logo-namecont">
                                <div className="footer-VirasatDefault-header-logo-namecont-title">
                                    Virasat
                                </div>
                                <div className="footer-VirasatDefault-header-logo-namecont-sub">
                                    fine dining
                                </div>
                            </div>
                        </div>
                        <div className="footer-VirasatDefault-subheader">
                            For a truly memorable dining experience, be sure to reserve your table in advance. Come and taste our remarkable food and wine.
                        </div>
                    </div>
                    {!isComingSoon && <div className="VirasatDefault-Footer-top-inner-cont">
                        <div className="footer-VirasatDefault-header">
                            QUICK LINKS
                        </div>
                        {links.map((link, key) => {
                            return (
                                <div className="footer-header-item" key={key}
                                    onClick={() => {
                                        history.push(link.Link)
                                    }}>
                                    {link.Title}
                                </div>
                            )
                        })}

                    </div>}
                    <div className="VirasatDefault-Footer-top-inner-cont">
                        <div className="footer-VirasatDefault-header">
                            ADDRESS
                        </div>
                        <div className="footer-header-item">
                            13-15, High Street, Staines-Upon-Thames, Surrey, TW18 4QY

                        </div>
                        <div className="margin-18" />
                        <div className="footer-header-item">
                            P:<b>+44 1784 463978</b>
                        </div>
                        <div className="footer-header-item">
                            E:<b> info@VirasatDefault.uk</b>
                        </div>
                    </div>
                    {!isComingSoon &&
                        <div className="VirasatDefault-Footer-top-inner-cont">
                            <div className="footer-VirasatDefault-header">
                                Get in touch
                            </div>
                            <div className="footer-header-item">
                                Get in touch with us for enquiries and collaborations.
                            </div>
                            <div className="footer-header-item-btn">
                                <Button
                                    text={"MAKE AN ENQUIRY"}
                                    onClick={() => {
                                        history.push("/contact")
                                    }} />
                            </div>

                        </div>}
                </div>
            </div>
            <div className="VirasatDefault-Footer-bottom">
                <div className="VirasatDefault-Footer-bottom-inner">
                    <div className="copy-right-text-footer-vi">2025 © Virasat. Designed by Ecologital (Pvt) ltd</div>
                    <div className="footer-img-cont">
                        <img alt="" src={fb} className="footer-img-cont-icon" />
                        <img alt="" src={twitter} className="footer-img-cont-icon" />
                        <img alt="" src={insta} className="footer-img-cont-icon" />
                        <img alt="" src={tripad} className="footer-img-cont-icon" />

                    </div>
                </div>
            </div>
        </div>
    )
}
export default Footer